import api from "./api";
import { Test } from "../types/industry";

/*  payload the API expects  */
export interface SaveTestPayload {
  name: string;
  settings: {
    time: number;
    pass: number;
    shuffle: boolean;
    showProgress: boolean;
  };
  questions: {
    prompt: string;
    type: string;
    image?: string;
    answers: { text: string; correct: boolean }[];
  }[];
}


export const listTests = (
  industryId?: number,
  softwareId?: number,
  signal?: AbortSignal,
) => {
  const params: any = {};
  if (industryId !== undefined && industryId !== null) params.industry = industryId;
  if (softwareId !== undefined && softwareId !== null) params.software = softwareId;
  return api.get<Test[]>("browse-tests/", { params, signal }).then((r) => r.data);
};

export const createTest = (data: Partial<Test>) =>
  api.post<Test>("tests/", data).then((r) => r.data);

export const deleteTest = (id: number) =>
  api.delete(`tests/${id}/`);

export interface RetakeTestPayload {
  email?: string;
  user_id?: number | string;
  test_id: number | string;
  body?: string;
}

export const retakeTest = (payload: RetakeTestPayload) => {
  // Only send defined fields
  const data: any = {};
  if (payload.email) data.email = payload.email;
  if (payload.user_id) data.user_id = payload.user_id;
  data.test_id = payload.test_id;
  if (payload.body !== undefined) data.body = payload.body;
  return api.post("retake-test/", data);
};